<template>
  <xm-page class="product-detail-page"  >
    <xm-page-content>
    <div  :class="`prod-content ${popupVisible?'noScroll':''}` ">
      <div v-if="productData.showFlag === 'YES'">
        <div v-if="productData.shelfState === 'YES'">
          <div v-if="productData.customerSideSaleState === 'YES' || fromShare">
            <div class="product_desc">
              <div class="product-img">
                <img :src="productImgUrl" />
              </div>
            </div>
            <div class="info-block">
              <div class="name">
                <div class="name-content">
                  <span>{{ productData.commodityAlias }}</span>

                  <span class="tag" v-if="productData.category === 'COURSE'">课程</span>
                  <span class="tag" v-if="productData.category === 'GOODS'">物品</span>
                  <span class="tag" v-if="productData.category === 'FEE_ITEM'">费用</span>
                  <span class="tag" v-if="productData.category === 'SUITE'">套餐</span>
                </div>
              </div>
              <div v-if="productData.category !== 'SUITE'" class="operation">
                <div>
                  <div class="price" v-if="productData.category === 'COURSE'">
                    <div v-if="selectCourseIndex === ''">
                      <span class="price-value">¥{{ sortCoursePrice(productData.coursePrices).totalPrice }}</span>
                      <span v-if="productData.coursePrices.length > 1">起</span>
                      <span class="unit" v-if="sortCoursePrice(productData.coursePrices).feeType === 'CLASS_HOUR'">
                        /{{ sortCoursePrice(productData.coursePrices).quantity }}课时
                      </span>
                      <span class="unit" v-if="sortCoursePrice(productData.coursePrices).feeType === 'MONTH'">
                        /{{ sortCoursePrice(productData.coursePrices).quantity }}个月
                      </span>
                      <span class="unit" v-if="sortCoursePrice(productData.coursePrices).feeType === 'DAY'">
                        /{{ sortCoursePrice(productData.coursePrices).quantity }}天
                      </span>
                      <span
                        class="line-price"
                        v-if="
                          sortCoursePrice(productData.coursePrices).underlinePrice &&
                            sortCoursePrice(productData.coursePrices).underlinePrice !== 0 &&
                            sortCoursePrice(productData.coursePrices).underlinePrice !== sortCoursePrice(productData.coursePrices).totalPrice
                        "
                      >
                        ¥{{ sortCoursePrice(productData.coursePrices).underlinePrice }}
                      </span>
                    </div>
                    <div v-else>
                      <span class="price-value">¥{{ productData.coursePrices[selectCourseIndex].totalPrice }}</span>
                      <span class="unit" v-if="productData.coursePrices[selectCourseIndex].feeType === 'CLASS_HOUR'">
                        /{{ productData.coursePrices[selectCourseIndex].quantity }}课时
                      </span>
                      <span class="unit" v-if="productData.coursePrices[selectCourseIndex].feeType === 'MONTH'">
                        /{{ productData.coursePrices[selectCourseIndex].quantity }}个月
                      </span>
                      <span class="unit" v-if="productData.coursePrices[selectCourseIndex].feeType === 'DAY'">
                        /{{ productData.coursePrices[selectCourseIndex].quantity }}天
                      </span>
                      <span
                        class="line-price"
                        v-if="
                          productData.coursePrices[selectCourseIndex].underlinePrice &&
                            productData.coursePrices[selectCourseIndex].underlinePrice !== 0 &&
                            productData.coursePrices[selectCourseIndex].underlinePrice !== productData.coursePrices[selectCourseIndex].totalPrice
                        "
                      >
                        ¥{{ productData.coursePrices[selectCourseIndex].underlinePrice }}
                      </span>
                    </div>
                  </div>
                  <div class="price" v-if="productData.category === 'GOODS'">
                    <span class="price-value">¥{{ productData.commodityPrice }}</span>
                    <span class="unit">/件</span>
                    <span
                      v-if="productData.underlinePrice && productData.underlinePrice !== 0 && productData.underlinePrice !== productData.commodityPrice"
                      class="line-price"
                    >
                      ¥{{ productData.underlinePrice }}/件
                    </span>
                  </div>
                  <div class="price" v-if="productData.category === 'FEE_ITEM'">
                    <span class="price-value">¥{{ productData.commodityPrice }}</span>
                    <span class="unit">/笔</span>
                    <span
                      v-if="productData.underlinePrice && productData.underlinePrice !== 0 && productData.underlinePrice !== productData.commodityPrice"
                      class="line-price"
                    >
                      ¥{{ productData.underlinePrice }}/笔
                    </span>
                  </div>
                </div>
                <div class="share">
                  <img class="pic" src="https://image.xiaomaiketang.com/xm/internal/n2ZmS82EG7.png" alt="" />
                  <span @click="openShareCover">分享</span>
                </div>
              </div>
              <div v-else>
                <div class="operation">
                  <div class="price" v-if="productData.category === 'SUITE'">
                    <span class="price-value">¥{{ productData.commodityPrice }}</span>
                    <span
                      v-if="productData.underlinePrice && productData.underlinePrice !== 0 && productData.underlinePrice !== productData.commodityPrice"
                      class="line-price"
                    >
                      ¥{{ productData.underlinePrice }}
                    </span>
                  </div>
                  <div class="share">
                    <img class="pic" src="https://image.xiaomaiketang.com/xm/internal/n2ZmS82EG7.png" alt="" />
                    <span @click="openShareCover">分享</span>
                  </div>
                </div>
                <div class="package" v-if="productData.category === 'SUITE'">
                  <div class="item" v-for="(suiteItem, suiteIndex) in productData.suiteDetails" :key="suiteIndex">
                    <div class="name">{{ suiteItem.commodityName }}</div>
                    <div
                      class="suit-goods-sku"
                      v-if="suiteItem.categoryType === 'GOODS' && suiteItem.goodsFeeItemInfo && suiteItem.goodsFeeItemInfo.multiSpecification"
                      @click="openSuitePop(suiteItem)"
                    >
                      <span class="suit-goods-sku_label">规格</span>
                      <div class="suit-goods-sku_box">
                        <span class="suit-goods-sku_name" v-if="suiteItem.selectedGoodsSkuDesc">{{ suiteItem.selectedGoodsSkuDesc }}</span>
                        <span class="suit-goods-sku_name" v-else>请选择规格</span>
                        <span class="suit-goods-sku_icon icon iconfont">&#xe68a;</span>
                      </div>
                    </div>
                    <div class="standard">
                      <span v-if="suiteItem.curSpec.commodityType === 'COURSE'"
                        >{{ suiteItem.actualAmount }}元{{
                          suiteItem.curSpec.commoditySpecs.containQuantity
                        }}{{ suiteItem.curSpec.commoditySpecs.measurementUnits }}</span
                      >
                      <span v-else>{{ suiteItem.curSpec.commoditySpecs.unitPrice }}元/{{ suiteItem.curSpec.commoditySpecs.measurementUnits }}</span>
                    </div>
                    <div class="card">
                      <div class="buy">
                        <span>购买</span>
                        <span :style="{ color: suiteItem.error && suiteItem.categoryType === 'GOODS' ? 'red' : '' }">
                          <span>
                            <span v-if="suiteItem.curSpec.commodityType === 'COURSE' && suiteItem.curSpec.commoditySpecs.containQuantity > 1">
                              {{ suiteItem.curSpec.commoditySpecs.containQuantity }}
                            </span>
                            <span v-else>
                              {{ suiteItem.quantity }}
                            </span>
                          </span>
                          <span v-if="suiteItem.unit === 'CLASS_HOUR'">课时</span>
                          <span v-if="suiteItem.unit === 'MONTH'">个月</span>
                          <span v-if="suiteItem.unit === 'DAY'">天</span>
                          <span v-if="suiteItem.unit === 'PIECE'">件</span>
                          <span v-if="suiteItem.unit === 'PACKET'">笔</span>
                        </span>
                      </div>
                      <div class="send" v-if="suiteItem.giftQuantity > 0">
                        <span>赠送</span>
                        <span
                          >{{ suiteItem.giftQuantity }}
                          <span v-if="suiteItem.giftUnit === 'CLASS_HOUR'">课时</span>
                          <span v-if="suiteItem.giftUnit === 'MONTH'">个月</span>
                          <span v-if="suiteItem.giftUnit === 'DAY'">天</span>
                          <span v-if="suiteItem.giftUnit === 'PIECE'">件</span>
                          <span v-if="suiteItem.giftUnit === 'PACKET'">笔</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="select-sku" @click="popShow" v-if="productData.category === 'COURSE' && productData.coursePrices.length > 1">
                <div class="title">规格</div>
                <div class="pick-item">
                  <div class="palceholder">
                    <span v-if="selectCourseIndex === ''">请选择规格</span>
                    <span v-else>已选:{{ productData.coursePrices[selectCourseIndex].priceName }}</span>
                  </div>
                  <span class="control icon iconfont">&#xe68a;</span>
                </div>
              </div>
              <!-- 费用  -->
              <div v-if="productData.category === 'FEE_ITEM'" class="sku-num">
                <div class="title">数量</div>
                <div class="sku-num-right">
                  <stepper :number="skuNumber" @change="handleSkuNumber" :max="9999999999"></stepper>
                </div>
              </div>
              <!-- 物品 -->
              <template v-if="productData.category === 'GOODS'">
                <div v-if="multiSpecification" class="select-sku" @click="popShow">
                  <div class="title">规格</div>
                  <div class="pick-item">
                    <div class="palceholder">
                      <span v-if="selectedGoodsSkuDesc">已选:{{ selectedGoodsSkuDesc }}</span>
                      <span v-else>请选择规格</span>
                    </div>
                    <span class="control icon iconfont">&#xe68a;</span>
                  </div>
                </div>
                <div class="sku-num" v-else>
                  <div class="title">
                    数量 <span class="stock-num" v-show="stockNum !== void 0">库存{{ stockNum | formatStock }}件</span>
                  </div>
                  <div class="sku-num-right">
                    <stepper :number="skuNumber" @change="handleSkuNumber" :max="stockNum"></stepper>
                  </div>
                </div>
              </template>
              <div class="product-detail">
                <div class="title">商品详情</div>
                <div class="desc" v-html="productData.detailContent"></div>
              </div>
              <div class="inst-desc">
                <div class="title">机构简介</div>
                <div class="desc">{{ inst.description }}</div>
              </div>
            </div>
            <div class="footer-bar">
              <div class="content">
                <div class="item" @click="toMall">
                  <div class="icon">
                    <img src="https://image.xiaomaiketang.com/xm/pTzX8Fm3kJ.png" class="icon-img" />
                  </div>
                  <div class="text">首页</div>
                </div>
                <div class="item" @click="toastContactInst" v-if="inst.contactPhone">
                  <div class="icon"><img class="icon-img" src="https://image.xiaomaiketang.com/xm/rGrT7Cxjp8.png" /></div>
                  <div class="text">机构顾问</div>
                  <a :href="'tel:' + inst.contactPhone" ref="callInst"></a>
                </div>
                <div class="item buy-item " style="marginRight:0.1rem">
                  <xm-button
                    :disabled="isStockEmpty ? true : false"
                    @click="isStockEmpty ? '' : handleDeal()"
                    :class="isStockEmpty ? 'buy-btn' : 'buy-btn active'"
                  >
                    {{ isStockEmpty ? '抢光了' : '立即购买' }}
                  </xm-button>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="down-con">
            <img src="https://image.xiaomaiketang.com/xm/internal/JrnKQ83BPa.png" class="down-img" />
            <div class="tip">商品已停用，请联系机构老师</div>
            <div @click="toMall" class="to-mall">
              查看更多商品
              <span class="icon iconfont" style="fontSize:0.2rem">&#xe611;</span>
            </div>
          </div>
        </div>
        <div v-else-if="productData.shelfState === 'NO'" class="down-con">
          <img src="https://image.xiaomaiketang.com/xm/internal/JrnKQ83BPa.png" class="down-img" />
          <div class="tip">商品已停用，请联系机构老师</div>
          <div @click="toMall" class="to-mall">
            查看更多商品
            <span class="icon iconfont" style="fontSize:0.2rem">&#xe611;</span>
          </div>
        </div>
      </div>
      <div v-else-if="productData.shelfState === 'NO'" class="down-con">
        <img src="https://image.xiaomaiketang.com/xm/internal/JrnKQ83BPa.png" class="down-img" />
        <div class="tip">商品不存在，请联系机构老师</div>
        <div @click="toMall" class="to-mall">
          查看更多商品
          <span class="icon iconfont" style="fontSize:0.2rem">&#xe611;</span>
        </div>
      </div>
      <share-cover :visible="showShareCover" @close="closeShareCover" />
    </div>
     <mt-popup v-model="popupVisible" position="bottom" class="bottom-popup" v-if="productData.category === 'COURSE' || multiSpecification">
        <div class="popup-content">
          <span class="icon iconfont closeIcon" @click="popupHide">&#xe664;</span>
          <!-- 课程 -->
          <template v-if="productData.category === 'COURSE'">
            <div class="price" v-if="selectCourseIndex === ''">
              <span class="value">¥{{ sortCoursePrice(productData.coursePrices).totalPrice }}</span>
              <span v-if="productData.coursePrices.length > 1">起</span>
              <span class="unit" v-if="sortCoursePrice(productData.coursePrices).feeType === 'CLASS_HOUR'">
                /{{ sortCoursePrice(productData.coursePrices).quantity }}课时
              </span>
              <span class="unit" v-if="sortCoursePrice(productData.coursePrices).feeType === 'MONTH'">
                /{{ sortCoursePrice(productData.coursePrices).quantity }}个月
              </span>
              <span class="unit" v-if="sortCoursePrice(productData.coursePrices).feeType === 'DAY'">
                /{{ sortCoursePrice(productData.coursePrices).quantity }}天
              </span>
              <span
                class="line-price"
                v-if="
                  sortCoursePrice(productData.coursePrices).underlinePrice &&
                    sortCoursePrice(productData.coursePrices).underlinePrice !== 0 &&
                    sortCoursePrice(productData.coursePrices).underlinePrice !== sortCoursePrice(productData.coursePrices).totalPrice
                "
              >
                ¥{{ sortCoursePrice(productData.coursePrices).underlinePrice }}
              </span>
            </div>
            <div class="price" v-else>
              <span class="value">¥{{ productData.coursePrices[selectCourseIndex].totalPrice }}</span>
              <span class="unit" v-if="productData.coursePrices[selectCourseIndex].feeType === 'CLASS_HOUR'">
                /{{ productData.coursePrices[selectCourseIndex].quantity }}课时
              </span>
              <span class="unit" v-if="productData.coursePrices[selectCourseIndex].feeType === 'MONTH'">
                /{{ productData.coursePrices[selectCourseIndex].quantity }}个月
              </span>
              <span class="unit" v-if="productData.coursePrices[selectCourseIndex].feeType === 'DAY'">
                /{{ productData.coursePrices[selectCourseIndex].quantity }}天
              </span>
              <span
                class="line-price"
                v-if="
                  productData.coursePrices[selectCourseIndex].underlinePrice &&
                    productData.coursePrices[selectCourseIndex].underlinePrice !== 0 &&
                    productData.coursePrices[selectCourseIndex].underlinePrice !== productData.coursePrices[selectCourseIndex].totalPrice
                "
              >
                ¥{{ productData.coursePrices[selectCourseIndex].underlinePrice }}
              </span>
            </div>
            <div class="sku-choosed">
              <span v-if="selectCourseIndex === ''">请选择规格</span>
              <span v-else>已选:{{ productData.coursePrices[selectCourseIndex].priceName }}</span>
            </div>
          </template>
          <!-- 物品 -->
          <template v-if="productData.category === 'GOODS'">
            <div class="goods-pop-price">价格：¥ {{ productData.commodityPrice }}</div>
            <div class="sku-choosed">
              <span v-if="selectedGoodsSkuDesc">已选:{{ selectedGoodsSkuDesc }}</span>
              <span v-else>请选择规格</span>
            </div>
          </template>
          <!-- 套餐物品 -->
          <template v-if="productData.category === 'SUITE'">
            <div class="goods-pop-price">
              {{ suiteGoodsItem.details && suiteGoodsItem.details.commodityName }}
            </div>
            <div class="sku-choosed">
              <span v-if="suiteGoodsItem.details && suiteGoodsItem.details.selectedGoodsSkuDesc">已选:{{ suiteGoodsItem.details.selectedGoodsSkuDesc }}</span>
              <span v-else>请选择规格</span>
            </div>
          </template>
          <!-- 课程规格列表 -->
          <div class="sku-area" v-if="productData.category === 'COURSE'">
            <div class="list">
              <span
                :class="['item', { 'active-item': selectCourseIndex === index }]"
                v-for="(item, index) in productData.coursePrices"
                :key="index"
                @click="changeCourse(index)"
                >{{ item.priceName }}</span
              >
            </div>
          </div>
          <!-- 物品规格列表 -->
          <div class="sku-area" v-if="productData.category === 'GOODS'">
            <div class="list">
              <div class="goods-sku-group" v-for="(skuItem, index) in skuAttrs" :key="index">
                <div class="goods-sku-name">{{ skuItem.attrName }}</div>
                <div class="goods-sku-list">
                  <span
                    :class="[
                      'goods-sku-item',
                      { 'goods-sku-item__disabled': isDisableSku(skuItem.attrName, valItem) },
                      { 'goods-sku-item__selected': goodsSkuSelected[skuItem.attrName] === valItem },
                    ]"
                    v-for="(valItem, vIndex) in skuItem.attrValue"
                    :key="vIndex"
                    @click="changeGoodsSku(skuItem.attrName, valItem)"
                    >{{ valItem }}</span
                  >
                </div>
              </div>
              <div class="goods-number-wrapper">
                <div class="goods-sku-name">
                  数量 <span class="stock-num" v-show="stockNum !== void 0">库存{{ stockNum | formatStock }}件</span>
                </div>
                <stepper :number="skuNumber" @change="handleSkuNumber" :max="stockNum"></stepper>
              </div>
            </div>
          </div>
          <!-- 套餐物品规格列表 -->
          <div class="sku-area" v-if="productData.category === 'SUITE'">
            <div class="list">
              <div class="goods-sku-group" v-for="(skuItem, index) in suiteGoodsItem.skuAttrs" :key="index">
                <div class="goods-sku-name">{{ skuItem.attrName }}</div>
                <div class="goods-sku-list">
                  <span
                    :class="[
                      'goods-sku-item',
                      { 'goods-sku-item__disabled': isDisableSku(skuItem.attrName, valItem) },
                      {
                        'goods-sku-item__selected':
                          suiteGoodsItem.details.goodsSkuSelected && suiteGoodsItem.details.goodsSkuSelected[skuItem.attrName] === valItem,
                      },
                    ]"
                    v-for="(valItem, vIndex) in skuItem.attrValue"
                    :key="vIndex"
                    @click="changeGoodsSkuForSuite(skuItem.attrName, valItem)"
                    >{{ valItem }}</span
                  >
                </div>
              </div>
              <div class="goods-number-wrapper">
                <div class="goods-sku-name">
                  数量
                  <span class="stock-num" v-show="suiteGoodsItem.details.selectedStockNum !== void 0"
                    >库存{{ suiteGoodsItem.details.selectedStockNum | formatStock }}件</span
                  >
                </div>
                <stepper disabled :number="suiteGoodsItem.details.quantity" :max="suiteGoodsItem.details.selectedStockNum"></stepper>
              </div>
            </div>
          </div>
        </div>
        <div class="buy-opera">
          <xm-button @click="handleConfirm" v-if="productData.category === 'SUITE'" class="buy-btn">确定</xm-button>
          <xm-button @click="handleDeal()" class="buy-btn" v-else>立即购买</xm-button>
        </div>
      </mt-popup>
    </xm-page-content>
  </xm-page>
</template>
<script>
import InstService from '../../service/InstitutionService';
import User from '@/core/user';
import WechatApi from '@/core/wechatApi';
import Platform from '@/core/platform';
import PayService from '@/service/PayService';
import Stepper from '@/components/Stepper';
import { CheckSpecEnum, CategoryUnitEnum } from '@/enum/MallEnum';
import { Toast } from 'vant';
import ShareCover from '@/module/common/ShareCover';

export default {
  components: {
    Stepper,
    ShareCover,
  },
  computed: {
    selectedGoodsSkuDesc: function() {
      if (this.productData.category === 'GOODS') {
        const desc = [];
        _.each(this.skuAttrs, i => {
          this.goodsSkuSelected[i.attrName] && desc.push(this.goodsSkuSelected[i.attrName]);
        });
        if (desc.length) {
          return `${desc.join('；')}；${this.skuNumber}件`;
        } else {
          return '';
        }
      }
    },
    isStockEmpty() {
      const { category, stock = 0, suiteDetails } = this.productData;

      if (category === 'SUITE') {
        let isEmptyStatusArr = Array.of();

        for (let item of suiteDetails) {
          const { categoryType, quantity, goodsFeeItemInfo } = item;

          if (categoryType === 'GOODS') {
            if (goodsFeeItemInfo.goodsSku) {
              const status = goodsFeeItemInfo.goodsSku.skuItems.every(item2 => {
                return item2.stockNum < quantity;
              });

              isEmptyStatusArr.push(status);
            }
          }
        }
        return isEmptyStatusArr.length && isEmptyStatusArr.every(status => status === true);
      } else if (category === 'GOODS') {
        return stock <= 0;
      }
      return false;
    },
  },
  data() {
    return {
      productImgUrl: '',
      inst: {},
      productData: {},
      popupVisible: false,
      selectSpecId: '',
      selectCourseIndex: '',
      skuNumber: 1, // 数量
      stockNum: 1, // void 0, // 库存
      instName: window.getParameterByName('instName'),
      query: {
        instId: this.$route.query.instId,
        commodityId: this.$route.query.commodityId,
      },
      goodsSkuSelected: {},
      multiSpecification: false,
      skuAttrs: [],
      skuItems: [],
      suiteGoodsItem: {
        details: {},
      },
      goodsDefaultImg: {
        COURSE: 'https://image.xiaomaiketang.com/xm/internal/eMdhFaJ3NF.png',
        GOODS: 'https://image.xiaomaiketang.com/xm/internal/BebQYQSnHz.png',
        FEE_ITEM: 'https://image.xiaomaiketang.com/xm/internal/BGDFZxjSzk.png',
        SUITE: 'https://image.xiaomaiketang.com/xm/internal/3XhA6MQnSG.png',
      },
      shareTitle: '',
      shareSubTitle: '',
      showShareCover: false,
      fromShare: false,
    };
  },
  created() {
    document.title='商品详情'
  },
  mounted() {
    if (!User.token() && Platform.isWeiXin()) {
      User.loginIn();
      return;
    }
    this.payType = Platform.isWeiXin() ? 4 : 3;
    if (Platform.isWeiXin()) {
      PayService.getAppid(this.payType).then(res => {
        this.appid = res.result;
      });
    }
    this.payType = Platform.isWeiXin() ? 4 : 3;
    if (Platform.isWeiXin()) {
      PayService.getAppid(this.payType).then(res => {
        this.appid = res.result;
      });
    }
    this.fetchProductDetail();
    this.fetchInstData();
    
  },
  watch: {
    popupVisible(currentVal) {
      if (this.productData.category === 'SUITE' && !currentVal) {
        const { skuAttrs, skuItems, details = {} } = this.suiteGoodsItem;
        const _keys = _.keys(details.goodsSkuSelected);
        if (_keys.length === 0 || (_keys.length > 0 && _keys.length < skuAttrs.length)) {
          this.$set(details, 'goodsSkuSelected', {});
          const _selectSpecId = this.getGoodsCombinSpecId(skuAttrs, skuItems, details.goodsSkuSelected);
          const _selectedGoodsSkuDesc = this.formateSkuDescForSuite(skuAttrs, details.goodsSkuSelected);
          this.$set(details, 'selectedGoodsSkuDesc', _selectedGoodsSkuDesc);
          this.$set(details, 'selectSpecId', _selectSpecId);
        }
      }
    },
  },
  methods: {
    fetchProductDetail() {
      var that = this;
      that.fromShare = window.getParameterByName('fromShare');
      axios.Customer('anon/mall/getCommodityDetail', this.query).then(res => {
        if (res.success) {
          console.log('商品信息', res.result);
          that.productData = res.result;
          that.productImgUrl = res.result.coverResource.resUrl || this.goodsDefaultImg[res.result.category];
          that.shareTitle = res.result.shareTitle;
          that.shareSubTitle = res.result.shareSubTitle;
          // 分享
          setTimeout(() => {
            this.doDetailShare();
          }, 500);
          // 库存
          this.stockNum = (res.result.stock || 0) * 1;
          if (!['COURSE', 'GOODS'].includes(res.result.category)) {
            this.selectSpecId = res.result.specId;
            if (res.result.category === 'SUITE') {
              this.multiSpecification = _.some(res.result.suiteDetails, suiteItem => {
                return suiteItem.goodsFeeItemInfo && suiteItem.goodsFeeItemInfo.multiSpecification;
              });
              window.sessionStorage.removeItem(`suite_${res.result.id}`);
            }
          }
          if (res.result.category === 'COURSE' && that.productData.coursePrices.length == 1) {
            this.selectSpecId = that.productData.coursePrices[0].specId;
          }
          if (res.result.category === 'GOODS') {
            const _goodsInfo = res.result.goodsInfo || {};
            const _skuItems = _goodsInfo.goodsSku && _goodsInfo.goodsSku.skuItems;
            if (_goodsInfo.multiSpecification && _skuItems && _skuItems.length > 1) {
              this.skuAttrs = _goodsInfo.goodsSku.skuAttrs;
              this.skuItems = _goodsInfo.goodsSku.skuItems;
              this.multiSpecification = _goodsInfo.multiSpecification;
            } else if (_goodsInfo.multiSpecification && _skuItems && _skuItems.length === 1) {
              this.skuAttrs = _goodsInfo.goodsSku.skuAttrs;
              this.skuItems = _goodsInfo.goodsSku.skuItems;
              this.multiSpecification = true;
              // this.selectSpecId = _goodsInfo.goodsSku.skuItems[0].specId
            } else {
              this.multiSpecification = false;
              this.selectSpecId = res.result.specId;
            }
          }
          $.get(res.result.detailResource.resUrl, res => {
            Vue.set(that.productData, 'detailContent', res);
          });
        }
      });
    },
    fetchInstData() {
      const id = this.$route.query.instId;
      InstService.getInstMicroSiteInfo(id)
        .then(res => {
          this.inst = res.result;
        })
        .catch(error => {})
        .finally(() => {});
    },
    handleSkuNumber({ value }) {
      this.skuNumber = value;
    },
    // 物品：选择物品规格
    changeGoodsSku(parentName, skuName) {
      if (this.goodsSkuSelected[parentName] === skuName) {
        this.$delete(this.goodsSkuSelected, parentName);
      } else {
        if (this.isDisableSku(parentName, skuName)) return;
        this.$set(this.goodsSkuSelected, parentName, skuName);
      }
      this.selectSpecId = this.getGoodsCombinSpecId(this.skuAttrs, this.skuItems, this.goodsSkuSelected);
      // 库存
      this.stockNum = this.getGoodsStockNum(this.skuAttrs, this.skuItems, this.goodsSkuSelected);
      // 购买数量
      this.skuNumber = 1;
      console.log('--------specid--------', this.selectSpecId);
    },
    // 套餐：选择物品规格
    changeGoodsSkuForSuite(parentName, skuName) {
      const { skuAttrs, skuItems, details = {} } = this.suiteGoodsItem;
      if (!details.goodsSkuSelected) {
        details.goodsSkuSelected = {};
      }
      if (details.goodsSkuSelected[parentName] === skuName) {
        this.$delete(details.goodsSkuSelected, parentName);
      } else {
        if (this.isDisableSku(parentName, skuName)) return;
        this.$set(details.goodsSkuSelected, parentName, skuName);
      }
      const _selectSpecId = this.getGoodsCombinSpecId(skuAttrs, skuItems, details.goodsSkuSelected);
      // 库存
      const _stockNum = this.getGoodsStockNum(skuAttrs, skuItems, details.goodsSkuSelected);
      const _selectedGoodsSkuDesc = this.formateSkuDescForSuite(skuAttrs, details.goodsSkuSelected);
      this.$set(details, 'selectedGoodsSkuDesc', _selectedGoodsSkuDesc);
      this.$set(details, 'selectSpecId', _selectSpecId);
      this.$set(details, 'selectedStockNum', _stockNum);
    },
    // 套餐：确定所选择物品校验
    handleConfirm() {
      const { skuAttrs, details = {} } = this.suiteGoodsItem;
      const _keys = _.keys(details.goodsSkuSelected);
      if (_keys.length === 0) {
        Toast({
          message: '请选择规格',
          position: 'middle',
          duration: 200,
        });
      } else if (_keys.length > 0 && _keys.length < skuAttrs.length) {
        const _tipsList = [];
        _.each(skuAttrs, i => {
          if (!_keys.includes(i.attrName)) {
            _tipsList.push(i.attrName);
          }
        });
        const tips = `请选择${_tipsList.join('；')}`;
        Vue.$wheatToast({
          message: tips,
          position: 'middle',
        });
      } else {
        this.popupVisible = false;
      }
    },
    // 校验规格值是否禁用
    isDisableSku(skuName, skuValue) {
      // 物品
      let skuItems = this.skuItems;
      let goodsSkuSelected = this.goodsSkuSelected;

      // 套餐
      if (this.productData.category === 'SUITE') {
        skuItems = this.suiteGoodsItem.skuItems;
        goodsSkuSelected = this.suiteGoodsItem.details.goodsSkuSelected || {};
      }
      if (_.isEmpty(goodsSkuSelected)) {
        const _skuItems = this.checkEnableSku(skuItems, skuName, skuValue);
        return _skuItems.length < 1;
      } else {
        const _keys = _.keys(goodsSkuSelected);
        const _values = _.values(goodsSkuSelected);
        // 有一种情况是disable时需要禁用
        return !_.every(_keys, (i, iIndex) => {
          // skuname相同 当前行不做disable处理
          if (i === skuName) {
            const _skuItems = this.checkEnableSku(skuItems, skuName, skuValue);
            return _skuItems.length > 0;
          }
          // skuname不同 筛选出所有与skuValue（_values[iIndex]）相同的项
          const _skuFilter = _.filter(skuItems, j => {
            const { skuItemInfo } = j;
            return skuItemInfo[i] === _values[iIndex];
          });
          const _skuItems = this.checkEnableSku(_skuFilter, skuName, skuValue);
          return _skuItems.length > 0;
        });
      }
    },
    // 校验规格组合是否启用
    checkEnableSku(skuItems, skuName, skuValue) {
      return _.filter(skuItems, i => {
        const { skuItemInfo, state, stockNum } = i;
        return skuItemInfo[skuName] === skuValue && state === 'ON' && stockNum > 0;
      });
    },
    // 套餐：格式化名称
    formateSkuDescForSuite(skuAttrs, goodsSkuSelected = {}) {
      const desc = [];
      _.each(skuAttrs, i => {
        goodsSkuSelected[i.attrName] && desc.push(goodsSkuSelected[i.attrName]);
      });
      return desc.join('；');
    },
    // 获取规格
    getGoodsSpec(skuAttrs, skuItems, goodsSkuSelected = {}) {
      const _key = _.keys(goodsSkuSelected);
      const _val = _.values(goodsSkuSelected);
      const skuLength = skuAttrs.length;

      if (_key.length !== skuLength) return {};
      const sku = _.find(skuItems, i => {
        const { skuItemInfo } = i;
        return _.every(_key, (j, jIndex) => {
          return skuItemInfo[j] === _val[jIndex];
        });
      });

      return sku;
    },
    // 获取规格id
    getGoodsCombinSpecId(skuAttrs, skuItems, goodsSkuSelected = {}) {
      const { specId = '' } = this.getGoodsSpec(...arguments);

      return specId;
    },
    // 获取规格数量
    getGoodsStockNum(skuAttrs, skuItems, goodsSkuSelected = {}) {
      const { stockNum = void 0 } = this.getGoodsSpec(...arguments);

      return stockNum;
    },
    // 套餐：open pop
    openSuitePop(suiteItem) {
      const { goodsFeeItemInfo = {}, curSpec = {} } = suiteItem;
      const { goodsSku = {} } = goodsFeeItemInfo;
      const { commoditySpecs = {} } = curSpec;
      this.suiteGoodsItem = {
        skuAttrs: goodsSku.skuAttrs || [],
        skuItems: goodsSku.skuItems || [],
        commodityPrice: commoditySpecs.unitPrice || 0,
        details: suiteItem,
      };
      this.popShow();
    },
    popShow() {
      this.popupVisible = true;
    },
    popupHide() {
      this.popupVisible = false;
    },
    changeCourse(index) {
      this.selectCourseIndex = index;
      this.selectSpecId = this.productData.coursePrices[index].specId;
    },
    checkSuiteGoodsBySpecId() {
      if (this.productData.category === 'SUITE' && this.multiSpecification) {
        const sessionInfo = {};
        _.each(this.productData.suiteDetails, suiteItem => {
          sessionInfo[suiteItem.commodityId] = suiteItem.selectSpecId;
        });
        window.sessionStorage.setItem(`suite_${this.productData.id}`, JSON.stringify(sessionInfo));
        return _.some(this.productData.suiteDetails, suiteItem => {
          return suiteItem.goodsFeeItemInfo && suiteItem.goodsFeeItemInfo.multiSpecification && !suiteItem.selectSpecId;
        });
      }
    },
    getCheckPurchaseItemParams() {
      let orderDetails;
      const instId = this.$route.query.instId;

      if (this.productData.category === 'SUITE') {
        orderDetails = this.productData.suiteDetails.map(item => {
          const { classId, quantity, giftQuantity, giftUnit, categoryType, specId, selectSpecId, unit } = item;

          return {
            classId,
            purchaseItemType: categoryType === 'COURSE' ? 'COURSE' : categoryType === 'GOODS' ? 'ARTICLE' : 'FEE',
            purchaseQuantity: quantity,
            giftNum: giftQuantity,
            giftUnit,
            specId: selectSpecId || specId,
            suiteCommodityId: this.productData.id,
            unit,
          };
        });
      } else {
        const { category, id, coursePrices } = this.productData;
        let unit;

        if (category === 'COURSE') {
          unit = coursePrices[this.selectCourseIndex || 0].feeType;
        } else {
          unit = CategoryUnitEnum[category].unit;
        }

        orderDetails = Array.of({
          purchaseItemType: category === 'COURSE' ? 'COURSE' : category === 'GOODS' ? 'ARTICLE' : 'FEE',
          purchaseQuantity: this.skuNumber,
          specId: this.selectSpecId,
          suiteCommodityId: id,
          unit,
        });
      }

      return {
        orderDetails,
        instId,
      };
    },
    // 校验提示
    renderCheckTips(specArr) {
      const suiteDetails = JSON.parse(JSON.stringify(this.productData.suiteDetails));

      if (suiteDetails.length) {
        suiteDetails.map(suite => {
          suite.error = false;
          specArr.map(spec => {
            if (suite.specId === spec) {
              suite.error = true;
            }
          });
        });
        this.productData.suiteDetails = suiteDetails;
      }
    },
    // 校验创建订单
    checkPurchaseItem() {
      const params = this.getCheckPurchaseItemParams();
      return axios.Customer('anon/order/checkPurchaseItem', params);
    },
    handleDeal() {
      const params = {
        commodityId: this.$route.query.commodityId,
        entrance: window.getParameterByName('fromShare') === 'true' ? 'LINK' : 'APP',
      };
      if (this.productData.category === 'GOODS') {
        params.commoditySpecs = [
          {
            specId: this.selectSpecId || 0,
            purchaseQuantity: this.skuNumber || 0,
          },
        ];
      } else if (this.productData.category === 'SUITE') {
        let _suiteDetail = this.productData.suiteDetails;
        let _commoditySpecs = []
        for (let j = 0; j < _suiteDetail.length; j++){
          if (_suiteDetail[j].categoryType == 'GOODS') {
            _commoditySpecs.push({
              specId: _suiteDetail[j].specId || 0,
              purchaseQuantity: _suiteDetail[j].quantity || 0,
            })
          }
        }
        params.commoditySpecs =_commoditySpecs
      }
      console.log('校验参数', params);
      axios.Customer('anon/mall/validateCommodityPurchase', params).then(res => {
        if (res.code == 200) {
          this.buySubmit();
        }
      });
    },
    async buySubmit() {
      if (!this.selectSpecId || this.checkSuiteGoodsBySpecId()) {
        let tips = '请选择规格';
        if (this.productData.category === 'GOODS') {
          const _keys = _.keys(this.goodsSkuSelected);
          if (_keys.length > 0 && _keys.length < this.skuAttrs.length) {
            const _tipsList = [];
            _.each(this.skuAttrs, i => {
              if (!_keys.includes(i.attrName)) {
                _tipsList.push(i.attrName);
              }
            });
            tips = `请选择${_tipsList.join('；')}`;
          }
        }
        Vue.$wheatToast({
          message: tips,
          position: 'middle',
          duration: 1000,
        });
      } else {
        if (Platform.isAlipay()) {
          if (!User.token()) {
            const checkParams = this.getCheckPurchaseItemParams();

            this.$router.push({
              name: 'zfblogin',
              query: {
                instId: this.$route.query.instId,
                instName: this.instName,
                commodityId: this.$route.query.commodityId,
                specId: this.selectSpecId,
                purchaseNum: this.skuNumber,
                appid: this.appid,
                checkParams: JSON.stringify(checkParams),
              },
            });
          } else {
            const checkRes = await this.checkPurchaseItem();
            const { checkPass, checkSpecIdsMap } = checkRes.result;

            if (checkPass) {
              this.$router.push({
                name: 'online_Order_confirm',
                query: {
                  instId: this.$route.query.instId,
                  commodityId: this.$route.query.commodityId,
                  specId: this.selectSpecId,
                  purchaseNum: this.skuNumber,
                  appid: this.appid,
                },
              });
            } else {
              const { category } = this.productData;

              for (let item of Object.entries(checkSpecIdsMap)) {
                if (category === 'SUITE') {
                  this.renderCheckTips(item[1]);
                }
                Vue.$wheatToast(CheckSpecEnum[item[0]].describe);
                return;
              }
            }
          }
        } else {
          const checkRes = await this.checkPurchaseItem();
          const { checkPass, checkSpecIdsMap } = checkRes.result;
          const { category } = this.productData;
          if (!checkPass) {
            for (let item of Object.entries(checkSpecIdsMap)) {
              if (category === 'SUITE') {
                this.renderCheckTips(item[1]);
              }
              Vue.$wheatToast(CheckSpecEnum[item[0]].describe);
              return;
            }
          } else {
            
            let path = window.location.origin + window.location.pathname;
            if (window.location.href.indexOf('fromBrandMiniapp') != -1 || localStorage.getItem('fromBrandMiniapp')) {
              //  判断是否从专属小程序进入
              path = `${path}?instId=${this.$route.query.instId}&fromBrandMiniapp=true&commodityId=${this.$route.query.commodityId}&specId=${this.selectSpecId}&purchaseNum=${this.skuNumber}#/online/order/confirm?fromShare=${window.getParameterByName('fromShare')}`;
            } else {
              path = `${path}?instId=${this.$route.query.instId}&commodityId=${this.$route.query.commodityId}&specId=${this.selectSpecId}&purchaseNum=${this.skuNumber}#/online/order/confirm?fromShare=${window.getParameterByName('fromShare')}`;
            }
            const reloadUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid}&redirect_uri=${window.encodeURIComponent(
              path,
            )}&response_type=code&scope=snsapi_base#wechat_redirect`;
            window.localStorage.removeItem('pay_openId');
            window.location.href = reloadUrl;

            // 确认订单-PC端调试
            // this.$router.push({
            //   name: 'online_Order_confirm',
            //   query: {
            //     instId: this.$route.query.instId,
            //     commodityId: this.$route.query.commodityId,
            //     specId: this.selectSpecId,
            //     purchaseNum: this.skuNumber,
            //     appid: this.appid,
            //   },
            // });
          }
        }
      }
    },
    toMall() {
      window.router.push({
        name: 'online_product_list',
        query: {
          instId: this.$route.query.instId,
          instName: this.inst.instName,
        },
      });
    },
    toastContactInst() {
      window
        .showConfirm('', `是否联系机构顾问？将拨打机构顾问热线${this.inst.contactPhone}`, '联系顾问', '取消')
        .then(() => {
          this.$refs.callInst.click();
        })
        .catch(() => {});
    },
    doDetailShare() {
      var that = this;
      WechatApi.doWapShare({
        title: that.shareTitle || '向你推荐了一个商品，赶紧看看吧',
        desc: that.shareSubTitle || '优质商品，点击查看',
        linkUrl:
          location.origin +
          location.pathname +
          '#/online/product/detail?instId=' +
          that.$route.query.instId +
          '&commodityId=' +
          that.$route.query.commodityId +
          '&appId=' +
          (that.$route.query.appId || User.appId()) ,
        imgUrl: that.productImgUrl,
        success: () => {
          this.closeShareCover();
        },
      });
      wx.miniProgram.postMessage({
        data: {
          title: that.shareTitle || '向你推荐了一个商品，赶紧看看吧',
          desc: that.shareSubTitle ||'优质商品，点击查看',
          linkUrl:
            location.origin +
            location.pathname +
            '#/online/product/detail?instId=' +
            that.$route.query.instId +
            '&commodityId=' +
            that.$route.query.commodityId +
            '&appId=' +
            (that.$route.query.appId || User.appId()) ,
          imgUrl: that.productImgUrl,
        },
      });
    },
    sortCoursePrice(theArr) {
      let theSmallPrice = theArr[0];
      for (var i = 0; i < theArr.length; i++) {
        if (theSmallPrice.totalPrice > theArr[i].totalPrice) {
          theSmallPrice = theArr[i];
        }
      }
      return theSmallPrice;
    },
    openShareCover() {
      this.showShareCover = true;
    },
    closeShareCover() {
      this.showShareCover = false;
    },
  },
};
</script>
<style lang="less">
.product-detail-page {
  
  .prod-content {
    overflow-x: scroll;
    height: 100%;
    &.noScroll{
      height: 100%;
      overflow: hidden;
  }
  }
  .product_desc {
    .product-img {
      width: 7.5rem;
      height: 7.5rem;
      > img {
        width: 7.5rem;
        // height: 7.5rem;
      }
    }
    .desc {
      text-align: left;
      padding: 0.24rem 0.32rem 0.1rem;
      background: #fff;
      .name {
        .name-content {
          font-size: 0.3rem;
          color: #4a4a4a;
          line-height: 0.42rem;
          font-weight: 500;
        }
        .tag {
          font-size: 0.22rem;
          color: #999999;
          border: 0.01rem solid #dddddd;
          padding: 0 0.08rem;
          height: 0.3rem;
          line-height: 0.3rem;
          margin-left: 0.04rem;
          border-radius: 2px;
          vertical-align: middle;
          display: inline-block;
        }
      }
      .price {
        .price-value {
          font-size: 0.5rem;
          color: #ff6934;
          font-weight: 500;
          height: 0.72rem;
          line-height: 0.72rem;
        }
        .unit {
          font-size: 0.22rem;
          line-height: 0.32rem;
          color: #999999;
        }
      }
      .package {
        padding: 0 0.2rem;
        background: #fafafa;
        border: 0.02rem solid #eee;
        margin: 0.16rem 0 0.22rem 0;
        border-radius: 0.1rem;
        .item {
          padding: 0.16rem 0;
          border-bottom: 0.02rem dashed #eee;
          .name {
            font-size: 0.3rem;
            color: #333333;
            line-height: 0.42rem;
            margin-bottom: 0.08rem;
          }
          .standard {
            span {
              font-size: 0.26rem;
              color: rgba(153, 153, 153, 1);
              line-height: 0.36rem;
            }
          }
          .card {
            font-size: 0.26rem;
            line-height: 0.36rem;
            color: #999999;
            margin-bottom: 0.08rem;
          }
          .buy {
            font-size: 0.26rem;
            line-height: 0.42rem;
            color: #333333;
            margin-bottom: 0.08rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            span {
              font-size: 0.26rem;
            }
          }
          .send {
            font-size: 0.26rem;
            line-height: 0.42rem;
            color: #333333;
            display: flex;
            justify-content: space-between;
            align-items: center;
            span {
              font-size: 0.26rem;
            }
          }
          &:last-child {
            border-bottom: 0px;
          }
        }
      }
    }
  }
  .info-block {
    border-radius: 0.16rem 0.16rem 0px 0px;
    background: #fff;
    width: 100%;
    padding: 0.32rem;
    .name {
      margin-bottom: 0.12rem;
      .name-content {
        text-align: left;
        font-size: 0.3rem;
        color: #4a4a4a;
        line-height: 0.42rem;
        font-weight: 500;
        font-family: PingFangSC-Medium, PingFang SC;
      }
      .tag {
        font-size: 0.22rem;
        color: #ff6934;
        border: 0.5px solid #ff6934;
        padding: 0 0.08rem;
        height: 0.3rem;
        line-height: 0.3rem;
        margin-left: 0.04rem;
        border-radius: 2px;
        vertical-align: middle;
        display: inline-block;
      }
    }
    .operation {
      display: flex;
      justify-content: space-between;

      .price {
        .price-value {
          font-size: 0.5rem;
          color: #ff6934;
          font-weight: 500;
          height: 0.72rem;
          line-height: 0.72rem;
        }
        .unit {
          font-size: 0.22rem;
          line-height: 0.32rem;
          color: #999999;
        }
      }
      .share {
        display: flex;
        align-items: center;
        font-size: 0.26rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 0.72rem;
        .pic {
          width: 0.32rem;
          height: 0.32rem;
          margin-right: 0.12rem;
        }
      }
    }
    .package {
      padding: 0 0.2rem;
      background: #f4f5fa;
      margin: 0.16rem 0 0.22rem 0;
      border-radius: 0.16rem;
      text-align: left;
      .item {
        padding: 0.16rem 0;
        border-bottom: 1px dashed #e6e8f7;
        .name {
          font-size: 0.3rem;
          color: #333333;
          line-height: 0.42rem;
          margin-bottom: 0.08rem;
        }
        .standard {
          span {
            font-size: 0.26rem;
            color: rgba(153, 153, 153, 1);
            line-height: 0.36rem;
          }
        }
        .card {
          font-size: 0.26rem;
          line-height: 0.36rem;
          color: #999999;
          margin-bottom: 0.08rem;
        }
        .buy {
          font-size: 0.26rem;
          line-height: 0.42rem;
          color: #333333;
          margin-bottom: 0.08rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          span {
            font-size: 0.26rem;
          }
        }
        .send {
          font-size: 0.26rem;
          line-height: 0.42rem;
          color: #333333;
          display: flex;
          justify-content: space-between;
          align-items: center;
          span {
            font-size: 0.26rem;
          }
        }
        &:last-child {
          border-bottom: 0px;
        }
      }
    }
  }
  .select-sku {
    background-color: #f4f5fa;
    display: flex;
    position: relative;
    padding: 0.28rem 0.32rem;
    width: 100%;
    align-items: center;
    margin-top: 0.2rem;
    border-radius: 0.16rem;
    justify-content: space-between;
    .title {
      margin-right: 0.72rem;
      font-size: 0.3rem;
      color: #333333;
      line-height: 0.42rem;
    }
    .pick-item {
      display: flex;
      .palceholder {
        font-size: 0.3rem;
        line-height: 0.42rem;
        color: #cccccc;
        margin-right: 0.16rem;
      }
      .control {
        font-size: 14px;
        color: #909090;
      }
    }
  }
  .sku-num {
    border-radius: 0.16rem;
    background-color: #f4f5fa;
    display: flex;
    position: relative;
    padding: 0.28rem 0.32rem;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.2rem;
    .title {
      margin-right: 0.72rem;
      font-size: 0.3rem;
      color: #333333;
      line-height: 0.42rem;
      .stock-num {
        font-size: 0.3rem;
        line-height: 0.36rem;
        color: #999999;
      }
    }
  }
  .product-detail {
    text-align: left;
    margin-top: 0.2rem;
    // background: #ffffff;
    font-family: PingFangSC-Medium, PingFang SC;
    .title {
      font-size: 0.3rem;
      color: #333333;
      line-height: 0.42rem;
      margin-bottom: 0.16rem;
      font-weight: 500;
    }
    .desc {
      font-size: 0.26rem;
      color: #666666;
      line-height: 0.36rem;
      p {
        font-size: 0.26rem;
        line-height: normal;
      }
      img {
        width: 100%;
        margin-top: 0.24rem;
        border-radius: 0.16rem;
      }
    }
  }
  .inst-desc {
    text-align: left;
    margin-top: 0.2rem;
    background: #ffffff;
    margin-bottom: 1.2rem;
    .title {
      font-size: 0.3rem;
      color: #333333;
      line-height: 0.42rem;
      margin-bottom: 0.16rem;
    }
    .desc {
      font-size: 0.26rem;
      color: #666666;
      line-height: 0.36rem;
      img {
        width: 100%;
        margin-top: 0.24rem;
        border-radius: 0.1rem;
      }
    }
  }

  .footer-bar {
    position: fixed;
    bottom: 0;
    background: #fff;
    width: 100%;
    box-shadow: 0px 0px 6px 0px rgba(233, 240, 253, 1);
    height: 1rem;
    z-index: 100;
    .content {
      display: flex;
      align-items: center;
      height: 1rem;
      .item {
        flex: 1;
        .icon {
          line-height: 1;
          .icon-img {
            width: 0.48rem;
            padding-top: 0.05rem;
          }
        }
        .text {
          font-size: 0.22rem;
          color: #666666;
        }
      }
      .buy-item {
        flex: 2;
        .buy-btn {
          margin: 0 auto;
          width: 4.16rem;
          height: 0.8rem;
          line-height: 0.8rem;

          border-radius: 0.5rem;
        }
        .active {
          background: linear-gradient(90deg, #ff7819 0%, #ff4200 100%);
        }
      }
    }
  }
  .bottom-popup {
    border-radius: 0.2rem 0.2rem 0 0;
    .popup-content {
      width: 100vw;
      min-height: 50vh;
      // padding: 0 0.32rem;
      text-align: left;
      position: relative;
      .price {
         padding: 0.24rem 0.32rem 0 0.32rem;
        .value {
          font-size: 0.3rem;
          color: #ff6934;
          line-height: 0.42rem;
          font-weight: 500;
        }
        .unit {
          font-size: 0.22rem;
          color: #999999;
          line-height: 0.32rem;
        }
        .line-price {
          font-size: 0.22rem;
          color: #999999;
          line-height: 0.32rem;
          text-decoration: line-through;
        }
      }
      .sku-choosed {
        padding: 0.08rem 0.32rem 0.24rem 0.32rem;
        border-bottom: 0.01rem solid #eee;
      }
      .sku-area {
        padding: 0.32rem;
        .list {
          padding-bottom: 0.8rem;
          max-height: 6.2rem;
          overflow-y: auto;
          .item {
            padding: 0.08rem 0.3rem;
            font-size: 0.3rem;
            color: #666666;
            line-height: 0.42rem;
            border: 0.02rem solid #dddddd;
            display: inline-block;
            margin-bottom: 0.16rem;
            margin-right: 0.16rem;
          }
          .active-item {
            background: rgba(255, 105, 52, 0.1);
            color: #ff6934;
            border: 0.02rem solid #ff6934;
          }
        }
        .goods-sku-group {
          &:not(:last-child) {
            margin-bottom: 0.32rem;
          }
        }
        .goods-sku-name {
          font-size: 0.26rem;
          color: #333333;
          line-height: 0.36rem;
        }
        .goods-sku-item {
          display: inline-block;
          padding: 0.06rem 0.3rem;
          margin-top: 0.16rem;
          font-size: 0.3rem;
          color: #666666;
          line-height: 0.4rem;
          border-radius: 0.1rem;
          border: 0.02rem solid #dddddd;
          &:not(:last-child) {
            margin-right: 0.16rem;
          }
        }
        .goods-sku-item__disabled {
          border-style: dashed;
          background: #f6f7f8;
          color: #cccccc;
        }
        .goods-sku-item__selected {
          border-color: #ff6934;
          background: rgba(255, 105, 52, 0.1);
          color: #ff6934;
        }
        .goods-number-wrapper {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 0.6rem;
          .goods-sku-name {
            .stock-num {
              font-size: 0.26rem;
              line-height: 0.36rem;
              color: #999999;
            }
          }
        }
      }
      .closeIcon {
        position: absolute;
        right: 0.32rem;
        font-size: 0.28rem;
        top: 0.2rem;
        color: #999;
      }
      .goods-pop-price {
        padding: 0.24rem 0 0 0.32rem;
        font-size: 0.3rem;
        font-weight: 500;
        color: #ff6934;
        line-height: 0.42rem;
      }
    }
    .buy-opera {
      position: fixed;
      bottom: 0;
      width: 100%;
      padding: 0 0.32rem;

      .buy-btn {
        margin-bottom: 0.2rem;
        background-image: linear-gradient(to right, #ff7819, #ff4200);
        height: 0.88rem;
        line-height: 0.88rem;
        font-size: 0.3rem;
        color: #fff;
      }
    }
  }
  .line-price {
    font-size: 0.22rem;
    color: #999999;
    line-height: 0.32rem;
    text-decoration: line-through;
  }
  .down-con {
    margin-top: 4rem;
    .down-img {
      width: 2.2rem;
      height: 2.2rem;
      display: inline-block;
    }
    .tip {
      font-size: 0.26rem;
      color: rgba(153, 153, 153, 1);
      line-height: 0.36rem;
      margin-bottom: 0.08rem;
    }
    .to-mall {
      font-size: 0.26rem;
      color: rgba(255, 105, 52, 1);
      line-height: 0.4rem;
    }
  }
}
.suit-goods-sku {
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 0.36rem;
  overflow: hidden;
  &_label {
    font-size: 0.26rem;
    color: #333333;
    margin-right: 0.48rem;
    flex-shrink: 0;
  }
  &_box {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    overflow: hidden;
  }
  &_name {
    font-size: 0.26rem;
    color: #666666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &_icon {
    flex-shrink: 0;
    font-size: 0.26rem !important;
    color: #666666;
  }
}
</style>



// WEBPACK FOOTER //
// src/module/mall/ProductDetail.vue